import PropTypes from 'prop-types';

import './styles/panelStyles.css';

const PanelLarge = ({ children, ...rest }) => (
  <div className="panel p-8" {...rest}>
    {children}
  </div>
);

PanelLarge.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PanelLarge;
